import * as React from 'react';
import {
    ArrayField,
    BooleanField,
    CloneButton,
    ChipField,
    Datagrid,
    DateField,
    EditButton,
    NumberField,
    ReferenceArrayField,
    ReferenceManyField,
    ReferenceManyCount,
    RichTextField,
    SelectField,
    ShowContextProvider,
    TabbedForm,
    SimpleFormIterator,
    ShowView,
    SingleFieldList,
    TextField,
    UrlField,
    useLocaleState,
    useRecordContext,
    DateInput,
    BooleanInput,
    TextInput,
    EditActionsProps,
    TopToolbar,
    ShowButton,
    CreateButton,
    Edit,
    required,
    SimpleForm,
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { Today } from '@mui/icons-material';
import { format } from 'date-fns';


const RanEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput
                source="sName"
                onKeyUp={event => {
                    if (event.key === 'Enter') {
                        event.stopPropagation();
                    }
                }}
            /> 
            <DateInput source="created_at" />
        </SimpleForm>
    </Edit>
);

export default RanEdit;
